// extracted by mini-css-extract-plugin
export default {"tag":"MultiSelectActivityTypeField_tag__peM9b","largeField":"MultiSelectActivityTypeField_largeField__3umaE"};